import { Component, OnInit, Input, Output, EventEmitter, SimpleChange } from '@angular/core';
import { CheckboxFilter, InputSearchFilter, DateSearch, RangeSearch } from 'src/app/interface/interfaces';
import { CalenderTranslationService } from 'src/app/services/calendar-translation/calendar-translation.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  @Input() checkboxes: Array<CheckboxFilter>;
  @Input() inputSearches: Array<InputSearchFilter>;
  @Input() searchDropDowns: Array<any>;
  @Input() dateSearches?: Array<DateSearch>;
  @Input() data: Array<any>;
  @Input() dateRangeSearches: Array<RangeSearch>;

  @Output() searchNew = new EventEmitter();
  @Output() dataFiltered = new EventEmitter();
  @Output() filterChechbox = new EventEmitter();
  filtered: Array<any>;
  changed = false;
  constructor(private calendarI18nService: CalenderTranslationService) { }

  ngOnInit() {
  }

  get calendarLocale(){
    return this.calendarI18nService.locale;
  }
  ngOnChanges(changes: { ['data']: SimpleChange }) {
    if (changes) {
      this.data = changes.data.currentValue;
      if (this.data) {
        this.filtered = this.performAllfilter();
        this.dataFiltered.emit(this.filtered);
      }
    }
  }
  checkSearch(searchItem: InputSearchFilter, event: KeyboardEvent) {
    if (searchItem.value.trim().length !== 0 && searchItem.value.trim().length < 3) {
      return;
    }
    if (this.changed && searchItem.value.trim().length === 0) {
      this.changed = false;
      this.searchNew.emit(searchItem);
      return;
    } else {
      if (event.key.toLowerCase() === 'enter') {
        this.searchNew.emit(searchItem);
        this.changed = true;
      } else {
        this.filtered = this.performAllfilter();
        this.dataFiltered.emit(this.filtered);
    }
   }
  }
  checkboxSearch(chechbox: CheckboxFilter) {
    chechbox.value = !chechbox.value;
    this.filtered = this.performAllfilter();
    this.dataFiltered.emit(this.filtered);
  }
  performAllfilter() {
    if (!this.data.length) {
      return;
    }
    let filtered  = this.data;
    if (this.checkboxes && this.checkboxes.length) {
      filtered = this.filterChecked(this.data);
    }
    if (this.inputSearches && this.inputSearches.length) {
      filtered = this.filterInput(filtered);
    }
    if (this.dateSearches && this.dateSearches.length) {
      filtered = this.filterDate(filtered);
    }
    if (this.dateRangeSearches && this.dateRangeSearches.length) {
      filtered = this.filterDateRange(filtered);
    }
    return filtered;
  }

  filterDate(data: Array<object>): object[] {
    if ( !this.dateSearches || this.dateSearches.length === 0) {
      return data;
    }
    return data.filter((dataElement) => {
     if (this.dateSearches.length === 1) {
       return this.compareDates(
                    dataElement[this.dateSearches[0].action],
                    Number(new Date(this.dateSearches[0].value).getTime()),
                    this.dateSearches[0].selectType
                  )
              || this.dateSearches[0].value === '';
     } else {
       let condition = true;
       for (const dateSearch of this.dateSearches) {
           condition  = condition && this.compareDates(
                                        dataElement[dateSearch.action],
                                        Number(new Date(dateSearch.value).getTime()),
                                        dateSearch.selectType
                                      )
                                  || dateSearch.value === '';
           if (!condition) {
           return false;
         } else {
           continue;
         }
       }
       return true;
     }
   });
  }

  filterChecked(data: Array<object>) {
    return data.filter(dataElement => {
       if (this.checkboxes.length === 1) {
         if (this.checkboxes[0].hasOwnProperty('Check') && this.checkboxes[0].Check.type === 'string') {
          return (dataElement[this.checkboxes[0].action].toLowerCase() === this.checkboxes[0].Check.testValue.toLowerCase())
                  || this.checkboxes[0].value  === false;
         } else if ( this.checkboxes[0].hasOwnProperty('Check') && this.checkboxes[0].Check.type === 'length') {
            return (dataElement[this.checkboxes[0].action].length > this.checkboxes[0].Check.testValue)
            || this.checkboxes[0].value  === false;
         }
         return (dataElement[this.checkboxes[0].action] === this.checkboxes[0].value) || this.checkboxes[0].value  === false;
       } else {
         let condition = true;
         for (const checkboxItem of this.checkboxes) {
            if (checkboxItem.hasOwnProperty('Check') && checkboxItem.Check.type === 'string') {
              condition = condition &&
                         (dataElement[checkboxItem.action].toLowerCase() === checkboxItem.Check.testValue.toLowerCase())
                         || checkboxItem.value === false;
           } else if (checkboxItem.hasOwnProperty('Check') && checkboxItem.Check.type === 'length') {
            condition = condition &&
                         (dataElement[checkboxItem.action] > checkboxItem.Check.testValue)
                         || checkboxItem.value === false;
           } else {
              condition = condition &&
              (dataElement[checkboxItem.action] === checkboxItem.value ) || checkboxItem.value === false;
           }
            if (!condition) {
             return false;
           } else {
             continue;
           }
         }
         return true;
       }
     });
   }
   filterInput(data: Array<object>) {
     if (this.inputSearches.length === 0 || !this.inputSearches) {
       return data;
     }
     return data.filter((dataElement) => {
        let condition = true;
        for (const inputSearch of this.inputSearches) {
          if (inputSearch.hasOwnProperty('degree') && inputSearch.degree === 2) {
            condition = condition && (dataElement[inputSearch.action[0]][inputSearch.action[1]]
              .toString()
              .toLowerCase()
              .includes(inputSearch.value.trim().toLowerCase())
            );
          } else {
            condition = condition && (dataElement[inputSearch.action]
                                    .toString()
                                    .toLowerCase()
                                    .includes(inputSearch.value.trim().toLowerCase())
                                  );
          }
          if (!condition) {
            return false;
          } else {
            continue;
          }
        }
        return true;
    });
   }
   filterDateRange(data) {
    if ( !this.dateRangeSearches || this.dateRangeSearches.length === 0) {
      return data;
    }
    return data.filter((dataElement) => {
       let condition = true;
       for (const dateRangeSearch of this.dateRangeSearches) {
           condition  = condition && this.isDateInRange([dataElement[dateRangeSearch.action[0]], dateRangeSearch.value[0]],
                                     [dataElement[dateRangeSearch.action[1]], dateRangeSearch.value[1]]);
           if (!condition) {
           return false;
         } else {
           continue;
         }
       }
       return true;
    });
   }
   dateSort(date, dateSearch: DateSearch, {input: el}) {
    this.setSelectType(el, dateSearch);
    if (!this.dateSearches || this.dateSearches.length === 0 ) {
      return;
     }
    if (!this.data.length) {
      return;
    }
    this.filtered = this.performAllfilter();
    this.dataFiltered.emit(this.filtered);
   }
   changeRangefilterCondition(date, keyType, dateRangeSearch: RangeSearch) {
    if (keyType === 'endDate') {
      dateRangeSearch.value[1] = new Date(date).getTime();
    } else if (keyType === 'startDate') {
      dateRangeSearch.value[0] = new Date(date).getTime();
    }

    this.filtered = this.performAllfilter();
    this.dataFiltered.emit(this.filtered);
   }
   compareDates(date1: number, date2: number, condition: string): boolean {
     let result: boolean;
     date1 = new Date(date1).setHours(0, 0, 0, 0);
     date2 = new Date(date2).setHours(0, 0, 0, 0);
     switch (condition) {
       case 'eq':
         result =  date1 === date2;
         break;
       case 'bfr':
        result = date1 < date2;
        break;
       case 'afr':
        result = date1 > date2;
        break;
       case 'all':
        result = true;
     }
     return result;
   }
   isDateInRange([startDate, filteredStartDate], [endDate, filteredEndDate]) {
    return (new Date(startDate).setHours(0, 0, 0, 0) >= new Date(filteredStartDate).setHours(0, 0, 0, 0) || filteredStartDate === null)
            && (new Date(endDate).setHours(0, 0, 0, 0) <= new Date(filteredEndDate).setHours(0, 0, 0, 0) || filteredEndDate === null) ;
   }
   changeDateFilterCondition({input: el}, dateSearch) {
    this.setSelectType(el, dateSearch);
    this.filtered = this.performAllfilter();
    this.dataFiltered.emit(this.filtered);
   }

   setSelectType(el, dateSearch) {
    const {el: select} = el;   // get select element ref from nglselect
    dateSearch.selectType = select.nativeElement.selectedOptions[0].attributes.value.nodeValue;
    // console.log(dateSearch.selectType);
    // console.log(dateSearch);
   }
}
